export const LOAD_DEFAULT_PPI_WEIGHTS = 'LOAD_DEFAULT_PPI';
export const CHANGE_PPI_TABLE_ITEM = 'CHANGE_PPI_TABLE_ITEM';
export const PPI_TABLE = 'PPI_TABLE';
export const ADD_PPI_TABLE_ROW = 'ADD_PPI_TABLE_ROW';
export const DELETE_PPI_TABLE_ROW = 'DELETE_PPI_TABLE_ROW';
export const LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST = 'LOAD_DEFAULT_TABLE_ROW_VISIBLE_LIST';



/** WEBPACK FOOTER **
 ** ../src/dash/front/ppi/constants.js
 **/